<template>
  <Modal
    actions
    :name="modalName"
    :title="$t('appointment.label.deleteFile')"
  >
    <template v-slot:body>
      <h3 class="red--text">
        {{ $t('upload.delete.title') }}
      </h3>
      <p>
        {{
          $t('upload.delete.deleteThis', {
            value: showFileName,
          })
        }}
      </p>
    </template>
    <template v-slot:actions>
      <v-btn
        @click="closeModal"
        :disabled="isAppointmentFilesDeleting"
        elevation="0"
        color="grey darken-1"
        text
      >
        {{ $t('deleteModal.buttons.cancel') }}
      </v-btn>
      <v-btn
        @click="handleDelete"
        :loading="isAppointmentFilesDeleting"
        elevation="0"
        class="ml-5"
        color="red"
        dark
      >
        {{ $t('deleteModal.buttons.deleteFile') }}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import Modal from '@/components/app/Modal'

export default {
  name: 'ModalAppointmentDeleteOneFile',

  props: {
    handleDelete: {
      type: Function,
      required: false,
    },
    modalName: {
      required: false,
      default: 'DELETE_ONE_APPOINTMENT_FILE'
    }
  },

  components: {
    Modal,
  },

  computed: {
    ...mapGetters([
      'activeModal',
      'appointmentFilesToDelete',
      'isAppointmentFilesDeleting',
    ]),

    showFileName() {
      return this.appointmentFilesToDelete.length > 0
        ? this.appointmentFilesToDelete[0].name
        : ''
    },
  },

  methods: {
    ...mapActions(['deleteAppointmentFile']),
    ...mapMutations(['closeAllModals']),

    closeModal() {
      this.$emit('resetSelectedFiles')
      this.closeAllModals()
    },
  },

  watch: {
    activeModal(value) {
      value === null && this.$emit('resetSelectedFiles')
    },
  },
}
</script>
